import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { AppButton } from '../commons/button';
import { observer, inject } from "mobx-react";
import i18next from 'i18next';
import { esclusioniOnResponseError } from '../../config/presdoc-fe-services-util';



@inject("rootStore")
@observer
class DettaglioButton extends React.Component {

  constructor(props) {
    super(props);
    this.item = this.props.item;
    this.element = this.props.element;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    this.valori = this.props.valori; 
    this.tipoPratica = this.props.tipoPratica;
    this.livelloTarget = this.props.livelloTarget;
    
  
  }

  

  componentDidMount() {
   
    
  }

 
   navigateToDettaglio()  {
   
    switch (this.livelloTarget) {
      case 3:
        this.ricevuteStore.loadAndNavigateToTerzoLivello(this.item, this.tipoPratica);
        break;
    
      default:
        return this.ricevuteStore.loadAndNavigateToSecondoLivello(this.valori, this.item, this.tipoPratica);  
        
    }
   }

  render() {

   

    
    const dettaglioButton = (item,element )=> {
        
        
      if(item.flagDettaglio === "1"){
        return <AppButton spanSrOnly="BUTTON_VAI_A_DETTAGLIO" color="outlined-blu" type="button" iconCenter="fas fa-eye" onClick={()=> this.navigateToDettaglio()} titleKey=''/>
        }
        else return " - "
  
  
  
  
    }

    
  
  
  
  
  
    return (
        dettaglioButton(this.item,this.element,this.navigateToDettaglio)

    );
      
    }
    

    }
    
   
  






//export default SceltaTipoInvio;

export {DettaglioButton}; 